export const DUPLICATE_EVENT_SCHEMA_ERROR_NAME = 'DUPLICATE_EVENT_SCHEMA';
export const DUPLICATE_EVENT_SCHEMA_ERROR_MESSAGE = `This event schema combination is already represented within the library`;
